import * as types from "./types";
import * as mutation_types from "./mutation_types";
import {
    TicketsSearch,
    ChangeTariff,
    GetVariants,
} from "./api/methods";
import Vue from 'vue'

export default {
    [types.A_TICKETS_SEARCH] ( context, payload ) {
        let cityFrom = payload.cityFrom;
        let cityTo = payload.cityTo;
        let countryTo = payload.countryTo;
        let dates = payload.date.dates.map(x => x.split("/").join("")).join("/");
        let days = payload.date.days;
        let adultCount = payload.people.adult.count;
        let childrenAges = payload.people.children.map(x => `ChildAges=${x.age}`);
        let rate = JSON.parse(localStorage.getItem("Rate")).Code;
        let rateIsoCode = JSON.parse(localStorage.getItem("Rate")).IsoCode;
        let date = new Date().getTime();

        let sendParam = `${context.state.API_URL}individuals/avia/` +
            `${cityFrom}/${cityTo}/${dates}?` +
            `AdultCount=${adultCount}&` +
            `AviaQuota=${context.state.aviaQuota}&` +
            (days ? `fromFlexible=${days}&toFlexible=${days}&` : "") +
            `CurrencyName=${rate}&` +
            (childrenAges.length ? childrenAges.join("&")+"&" : "") +
            `PageNumber=1&PageSize=10000&_=${date}`;

        context.state.mainParams = `individuals/avia/` +
            `${cityFrom}/${cityTo}/${dates}?` +
            `AdultCount=${adultCount}&` +
            `AviaQuota=${context.state.aviaQuota}&` +
            (days ? `fromFlexible=${days}&toFlexible=${days}&` : "") +
            `CurrencyName=${rate}&` +
            (childrenAges.length ? childrenAges.join("&")+"&" : "") +
            `PageNumber=1&PageSize=10000`;

        let dateFrom = dates.split("/")[0];
        let dateTo = dates.split("/")[1];
        childrenAges = payload.people.children.map(x => x.age).join(',');

        let URL = `?departureCity=${cityFrom}&` +
            `destinationCountry=${countryTo}&` +
            `destinationCity=${cityTo}&` +
            `departureDate=${dateFrom}&` +
            (dateTo ? "returnDate="+dateTo+"&" : "") +
            (days ? "flexible="+days+"&" : "") +
            `adultCount=${adultCount}&` +
            (childrenAges ? `childAges=${childrenAges}&` : "") +
            `aviaQuota=${context.state.aviaQuota}&` +
            `currency=${rateIsoCode}`;

        context.state.urlParams = URL;

        return new Promise((resolve) => {
            TicketsSearch(sendParam)
                .then((res) => {
                    setTimeout(() => {
                        const rate = JSON.parse(localStorage.getItem("Rate"));
                        context.state.lastRequest = sendParam;
                        let result = res.data.Result.map(x => {
                            x.rate = {...rate};
                            return x
                        });
                        context.state.cashSearchResult = [...result];
                        context.state.searchResult = [...result];

                        // const secondFilters = { ...res.data.SecondaryFiltersResult, ...res.data.FlightsMinimalAndMaximalCost };
                        const secondFilters = {
                          ...res.data.SecondaryFiltersResult,
                          minimalPrice: null,
                          maximalPrice: null,
                        };
                        context.state.secondaryFiltersResult = secondFilters;
                        context.commit(mutation_types.M_SET_SEARCHED, true);
                    },100);
                    resolve(URL)
                })
        })
    },
    [types.A_CHANGE_RESULT_CURRENCY] ( context ) {
        let rate = JSON.parse(localStorage.getItem("Rate")).Code;
        let date = new Date().getTime();

        let currencyName = new RegExp(`CurrencyName=${rate}\\&`);

        let sendParam = context.state.lastRequest;
        sendParam = sendParam.replace(/CurrencyName=.+&/, currencyName)
            .replace("&/", "&")
            .replace("\\&/", "&")
            .replace(/_=.+/, `_=${date}`);

        return new Promise((resolve) => {
            TicketsSearch(sendParam)
                .then((res) => {
                    const rate = JSON.parse(localStorage.getItem("Rate"));
                    let result = res.data.Result.map(x => {
                        x.rate = {...rate};
                        return x
                    });
                    context.state.cashSearchResult = [...result];
                    context.state.searchResult = [...result];
                    resolve()
                })
        })
    },
    [types.A_CHANGE_SECOND_FILTER] ( context, data ) {
        const date = new Date().getTime();
        let flightNoTransfer = false;
        let flightNumberTransfer = null;
        if (data.ticketsTransplantation.length) {
            flightNoTransfer = data.ticketsTransplantation.map(x => x.value).includes(0);
            flightNumberTransfer = data.ticketsTransplantation.map(x => x.value).reduce((accum, val) => accum + val);
        }
        let combineAirlines = data.ticketsAirlinesMulty;
        let combineTariffs = data.ticketsClassMulty;
        context.state.mainParams = context.state.mainParams.replace(/AviaQuota=\d/, `AviaQuota=${data.aviaQuota}`);

        let sendParams = context.state.API_URL + `${context.state.mainParams}` +
            (data.ticketsAirlines.length ? `${data.ticketsAirlines.map(x => `&Airline=${x.Code}`).join("&")}` : "") +
            (data.ticketsDepartureAirports.length ? `${data.ticketsDepartureAirports.map(x => `&AirportDeparture=${x.Code}`).join("&")}` : "") +
            (data.ticketsArrivalAirports.length ? `${data.ticketsArrivalAirports.map(x => `&AirportArrival=${x.Code}`).join("&")}` : "") +
            (data.ticketsClass.length ? `${data.ticketsClass.map(x => `&Tariff=${x.Key}`).join("&")}` : "") +
            (flightNoTransfer ? `&departureFlightNoTransfer=true` : "") +
            (flightNoTransfer ? `&arrivalFlightNoTransfer=true` : "") +
            (combineAirlines ? `&combineAirlines=true` : "") +
            (combineTariffs ? `&combineTariffs=true` : "") +
            (flightNumberTransfer ? `&departureFlightNumberTransfer=${flightNumberTransfer}` : "") +
            (flightNumberTransfer ? `&arrivalFlightNumberTransfer=${flightNumberTransfer}` : "") +
            (data.price[0] > 0 ? `&minPrice=${data.price[0]}` : "") +
            (data.price[1] ? `&maxPrice=${data.price[1]}` : "") +
            `&timeArrivalFrom=${data.arrivalTime[0]}` +
            `&timeArrivalTo=${data.arrivalTime[1]}` +
            `&timeDepartureFrom=${data.departureTime[0]}` +
            `&timeDepartureTo=${data.departureTime[1]}` +
            `&_=${date}`;
        sendParams = sendParams.replace(/&+/g, "&");

        return new Promise((resolve) => {
            Vue.Api.Get(sendParams)
                .then(res => {
                    const secondFilters = { ...res.data.SecondaryFiltersResult, ...res.data.FlightsMinimalAndMaximalCost };
                    context.state.secondaryFiltersResult = secondFilters;
                    resolve(res)
                });
        });
    },
    [types.A_SET_SEARCH_SECOND_PARAMS] ( context, data ) {
        context.state.filterParams = data;
        const date = new Date().getTime();

        let flightNoTransfer = false;
        let flightNumberTransfer = null;
        if (data.ticketsTransplantation.length) {
            flightNoTransfer = data.ticketsTransplantation.map(x => x.value).includes(0);
            flightNumberTransfer = data.ticketsTransplantation.map(x => x.value).reduce((accum, val) => accum + val);
        }

        let flightNoTransferArrival = false;
        let flightNumberTransferArrival = null;
        if (data.ticketsTransplantationArrival.length) {
            flightNoTransferArrival = data.ticketsTransplantationArrival.map(x => x.value).includes(0);
            flightNumberTransferArrival = data.ticketsTransplantationArrival.map(x => x.value).reduce((accum, val) => accum + val);
        }

        let combineAirlines = data.ticketsAirlineMulty;
        let combineTariffs = data.ticketsClassMulty;

        context.state.urlParams = context.state.urlParams.replace(/aviaQuota=\d/, `aviaQuota=${data.aviaQuota}`);

        const rate = JSON.parse(localStorage.getItem("Rate"))

        context.state.urlParams = context.state.urlParams.split("&").map(x => {
            if (x.includes("currency")) {
                x = `currency=${rate.IsoCode}`
            }
            return x
        }).join("&");

        context.state.mainParams = context.state.mainParams
            .split('&')
            .map(x => {
                if (x.includes("CurrencyName")) {
                    x = `CurrencyName=${rate.Code}`
                }
                return x
            })
            .join('&');

        let timeAFrom = data.arrivalTime[0] && data.arrivalTime[0] !== "00:00";
        let timeATo = data.arrivalTime[1] && data.arrivalTime[1] !== "23:59";
        let timeDFrom = data.departureTime[0] && data.departureTime[0] !== "00:00";
        let timeDTo = data.departureTime[1] && data.departureTime[1] !== "23:59";

        let urlParams = (flightNoTransfer ? `&departureFlightNoTransfer=true` : "") +
            (flightNoTransferArrival ? `&arrivalFlightNoTransfer=true` : "") +
            (combineAirlines ? `&combineAirlines=true` : "") +
            (combineTariffs ? `&combineTariffs=true` : "") +
            (data.ticketsAirlines.length ? `&airlines=${data.ticketsAirlines.map(x => x.Code).join(",")}` : "") +
            (data.ticketsDepartureAirports.length ? `&airportDeparture=${data.ticketsDepartureAirports.map(x => x.Code).join(",")}` : "") +
            (data.ticketsArrivalAirports.length ? `&airportArrival=${data.ticketsArrivalAirports.map(x => x.Code).join(",")}` : "") +
            (data.ticketsClass.length ? `&tariff=${data.ticketsClass.map(x => x.Key).join(",")}` : "") +
            (flightNumberTransfer ? `&departureFlightNumberTransfer=${flightNumberTransfer}` : "") +
            (flightNumberTransferArrival ? `&arrivalFlightNumberTransfer=${flightNumberTransferArrival}` : "") +
            (data.minPrice > 0 ? `&minPrice=${data.minPrice}` : "") +
            (data.maxPrice ? `&maxPrice=${data.maxPrice}` : "") +
            (timeAFrom ? `&timeArrivalFrom=${data.arrivalTime[0]}` : "") +
            (timeATo ? `&timeArrivalTo=${data.arrivalTime[1]}` : "") +
            (timeDFrom ? `&timeDepartureFrom=${data.departureTime[0]}` : "") +
            (timeDTo ? `&timeDepartureTo=${data.departureTime[1]}` : "");

        context.state.mainParams = context.state.mainParams.replace(/AviaQuota=\d/, `AviaQuota=${data.aviaQuota}`);

        let sendParams = context.state.API_URL + `${context.state.mainParams}` +
            (data.ticketsAirlines.length ? `${data.ticketsAirlines.map(x => `&Airline=${x.Code}`).join("&")}` : "") +
            (data.ticketsDepartureAirports.length ? `${data.ticketsDepartureAirports.map(x => `&AirportDeparture=${x.Code}`).join("&")}` : "") +
            (data.ticketsArrivalAirports.length ? `${data.ticketsArrivalAirports.map(x => `&AirportArrival=${x.Code}`).join("&")}` : "") +
            (data.ticketsClass.length ? `${data.ticketsClass.map(x => `&Tariff=${x.Key}`).join("&")}` : "") +
            (flightNoTransfer ? `&departureFlightNoTransfer=true` : "") +
            (flightNoTransferArrival ? `&arrivalFlightNoTransfer=true` : "") +
            (combineAirlines ? `&combineAirlines=true` : "") +
            (combineTariffs ? `&combineTariffs=true` : "") +
            (flightNumberTransfer ? `&departureFlightNumberTransfer=${flightNumberTransfer}` : "") +
            (flightNumberTransferArrival ? `&arrivalFlightNumberTransfer=${flightNumberTransferArrival}` : "") +
            (data.minPrice > 0 ? `&minPrice=${data.minPrice}` : "") +
            (data.maxPrice ? `&maxPrice=${data.maxPrice}` : "") +
            (data.arrivalTime[0] ? `&timeArrivalFrom=${data.arrivalTime[0]}` : "") +
            (data.arrivalTime[1] ? `&timeArrivalTo=${data.arrivalTime[1]}` : "") +
            (data.departureTime[0] ? `&timeDepartureFrom=${data.departureTime[0]}` : "") +
            (data.departureTime[1] ? `&timeDepartureTo=${data.departureTime[1]}` : "") +
            `&_=${date}`;
        sendParams = sendParams.replace(/&+/g, "&")
        this.lastRequest = sendParams;

        return new Promise((resolve) => {
            Vue.Api.Get(sendParams)
                .then(res => {
                    context.state.cashSearchResult = res.data.Result;
                    const rate = JSON.parse(localStorage.getItem("Rate"));
                    let result = res.data.Result.map(x => {
                        x.rate = {...rate};
                        return x
                    });
                    context.state.cashSearchResult = [...result];
                    context.state.searchResult = [...result];

                    const secondFilters = { ...res.data.SecondaryFiltersResult, ...res.data.FlightsMinimalAndMaximalCost };
                    context.state.secondaryFiltersResult = secondFilters;
                    let finalUrl = context.state.urlParams + "" + urlParams;
                    context.commit(mutation_types.M_SET_SEARCHED, true);
                    context.state.searchedSecondFilters = true;
                    resolve(finalUrl)
                });
        });
    },
    [types.A_SET_DATE] ( context, payload ) {
        context.commit(mutation_types.M_SET_DATE, payload);
    },
    [types.A_SET_DIRECT] ( context, payload ) {
        context.commit(mutation_types.M_SET_DIRECT, payload);
    },
    [types.A_CHANGE_TARIFF] ( context, payload ) {
        return new Promise((resolve) => {
            const sendParams = {
                url: `${context.state.API_URL}individuals/avia/calculate`,
                params: payload
            }
            ChangeTariff(sendParams)
                .then(res => {
                    resolve(res.data)
                });
        });
    },
    [types.A_SET_API_URL] ( context, payload ) {
        context.commit(mutation_types.M_SET_API_URL, payload)
    },
    [types.A_SET_API_ORIGIN] ( context, payload ) {
        context.commit(mutation_types.M_SET_API_ORIGIN, payload)
    },
    [types.A_GET_VARIANTS] ( context, payload ) {
        return new Promise((resolve) => {
            const date = new Date().getTime();

            const sendParams = `${context.state.API_URL}individuals/avia/variants` +
                `/${payload.cityDeparture}` +
                `/${payload.cityArrival}` +
                `/${payload.startDate}` +
                `/${payload.backDate}?` +
                `AdultCount=${payload.adult}&` +
                `CurrencyName=${payload.currency}&` +
                `AviaQuota=7&` +
                `TourKey=${payload.tourKey}&` +
                `_=${date}`;

            GetVariants(sendParams)
                .then(res => {
                    resolve(res.data)
                });
        });
    },
};
